import { useAtom } from 'jotai';

import {
	Button,
	Dropdown,
	Group,
	Popup,
	PopupTrigger,
	Stack,
	Text,
} from '@ekhodealer/ekho-common/rev';

import { selectedMonthAtom,selectedYearAtom } from '../atoms/usageAtoms';

import PlanDetailsWrapper from './PlanDetailsWrapper';

export default function UsageToolbar() {
	const [selectedYear, setSelectedYear] = useAtom(selectedYearAtom);
	const [selectedMonth, setSelectedMonth] = useAtom(selectedMonthAtom);
	const currentYear = new Date().getFullYear();

	// Generate year options from 2025 to current year
	const yearOptions = Array.from({ length: currentYear - 2025 + 1 }, (_, i) => ({
		id: String(2025 + i),
		label: String(2025 + i),
	}));

	// Generate month options
	const monthOptions = [
		{ id: '0', label: 'January' },
		{ id: '1', label: 'February' },
		{ id: '2', label: 'March' },
		{ id: '3', label: 'April' },
		{ id: '4', label: 'May' },
		{ id: '5', label: 'June' },
		{ id: '6', label: 'July' },
		{ id: '7', label: 'August' },
		{ id: '8', label: 'September' },
		{ id: '9', label: 'October' },
		{ id: '10', label: 'November' },
		{ id: '11', label: 'December' },
	];

	return (
		<Group>
			<Stack>
				<Text size='bodySmall' color='secondary'>
					Period
				</Text>
				<Group>
					<Dropdown
						onSelectionChange={setSelectedYear}
						options={yearOptions}
						className='dropdown'
						placeholder='Select year'
						value={selectedYear}
					/>
					<Dropdown
						onSelectionChange={setSelectedMonth}
						options={monthOptions}
						placeholder='Select month'
						value={selectedMonth}
						className='dropdown'
					/>
				</Group>
			</Stack>
			<PopupTrigger>
				<Button>Plan Details</Button>
				<Popup title='Plan Details' size='medium'>
					{() => <PlanDetailsWrapper />}
				</Popup>
			</PopupTrigger>
		</Group>
	);
}
